import _ from 'lodash';

/*
*  Helper to calculate profile wallet totals and rankings.
*/

const calculateWalletTotal = (transactions) => {
	let total = 0;
	if(!transactions) return total;
	_.forEach(transactions, transaction => {
		// console.log('t',transaction)
		total += transaction.amount;
	});
	return total;
}

const profilesByWallet = (profiles) => {
	// Reverse the education order so 4 (university) is first,
	// secondary sort by the earliest updated education
	profiles = _.filter(profiles, {'permission' : 'participant'});
	profiles = _.orderBy(profiles,[(p) => {
		let total = calculateWalletTotal(p.transactions),
		order = 1 / total;
		order = total < 0 ? order + 1 : order;
		return order;
	}]);
	return profiles
}

const profilesByEducation = (profiles) => {
	// Reverse the education order so 4 (university) is first,
	// secondary sort by the earliest updated education
	profiles = _.filter(profiles, {'permission' : 'participant'});
	profiles = _.orderBy(profiles,[(p) => {
		return 1 / p.education;
	},(p) => {
		return p.educationUpdated;
	}])
	return profiles
}

const profileOfLeaders = (profiles) => {
	// Return only profiles with permission === 'leader'
	profiles = _.filter(profiles, {'permission' : 'leader'})
	// console.log('leaders',profiles);
	return profiles
}


const Display = {

	walletTotal : (transactions) => {
		return calculateWalletTotal(transactions);
	},

	totalParticipants : (profiles) => {
		// console.log("totalParticipants",profiles);
		if(!profiles) return 0;
		profiles = _.filter(profiles, {'permission' : 'participant'});
		return Object.keys(profiles).length;
	},

	orderProfilesByWallet : (profiles) => {
		return profilesByWallet(profiles);
	},

	orderProfilesByEducation : (profiles) => {
		return profilesByEducation(profiles);
	},

	getLeaderProfiles : (profiles) => {
		return profileOfLeaders(profiles);
	},

	get profilesByWallet () {
		return this.profilesByWallet;
	},
	get profilesByEducation () {
		return this.profilesByWallet;
	},

	walletRank : (profileId, profiles) => {
		let rank = 0,
		sortedProfiles = profilesByWallet(profiles);
		rank = _.findIndex(sortedProfiles, {id : profileId}) + 1;
		return rank;
	},

	educationRank : (profileId, profiles) => {
		let rank = 0,
		sortedProfiles = profilesByEducation(profiles);
		rank = _.findIndex(sortedProfiles, {id : profileId}) + 1;
		return rank;
	},

	educationName : (education) => {
		let names = [
			'No Education',
			'Primary School',
			'High School',
			'University'
		];
		if(!education || !names[education]) return names[0];
		return names[education];
	},

};

export default Display;



// WEBPACK FOOTER //
// ./src/components/helpers/display.js